
<template>
  <div class="contain" ref="scrollRef">
    <div class="banner" ref="banner">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="item in bannerList" :key="item.img"  :style="{ backgroundImage: `url(${item.img==undefined?'': domain + item.img})` }">
          <div class="wrap">
            <div class="caption wow animate bounceInLeft delay-5s">
              {{ item.title }}
            </div>
            <div class="caption-info wow bounceInRight">
              {{ item.desc }}
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- <div class="banner" ref="banner">
      <div class="wrap">
        <div class="caption wow animate bounceInLeft delay-5s">
          智慧公卫信息方案 提供商
        </div>
        <div class="caption-info wow bounceInRight">
          科技创新 数智赋能 价值共振
        </div>
      </div>
    </div> -->
    <div class="tol">
      <div class="serve-area">
        <div class="wrap">
          <div class="provide">
            <div
              class="title"
              :style="{ backgroundImage: `url(${serve_area.img == undefined?'': domain + serve_area.img})` }"
            >
              <!-- <div class="t1 wow fadeInDown">我们为您提供专业的服务</div>
              <div class="info wow fadeInDown">应用科技力量 护佑生命健康</div> -->
              <div class="t1 wow fadeInDown">{{ serve_area.title }}</div>
              <div class="info wow fadeInDown">{{ serve_area.info }}</div>
            </div>
            <div class="plans">
              <!-- <div class="item wow fadeIn">
                <div class="english-name">Family Doctor Solutions</div>
                <div class="item-title">家庭医生解决方案</div>
                <div class="item-info">
                  充分围绕管理签、约、履、管、续各个流程进行全流程管理，致力于基层居民健康信息系统健身，实现闭环式管理，数据实时上传，有证可依，有据可查
                </div>
                <div class="item-icon" @click="goPage(1, '/familyDoctor')">
                  <img src="../assets/img/icon/icon_gd1@2x.png" alt="" />
                </div>
              </div> -->
              <div
                class="item wow fadeIn"
                :style="{
                  backgroundImage: `url(${serve_area.list[0].img == undefined?'':domain + serve_area.list[0].img})`,
                }"
              >
                <div class="english-name">{{ serve_area.list[0].content }}</div>
                <div class="item-title">{{ serve_area.list[0].title }}</div>
                <div class="item-info">
                  {{ serve_area.list[0].desc }}
                </div>
                <div
                
                  class="item-icon"
                  @click="goPage(1, serve_area.list[0].url)"
                >
                  <img src="../assets/img/icon/icon_gd1@2x.png" alt="" />
                </div>
              </div>
              <!-- <div class="item blue wow fadeIn">
                <div class="english-name">Smart public health solutions</div>
                <div class="item-title">智慧公卫解决方案</div>
                <div class="item-info">
                  以智能终端机为核心，通过身份证识别面部信息采集，搭载N个并列式系统及对应的数字化检测设备，一站式完成全体检流程、实现公共卫生服务过程中无纸化、信息化、智能化、规范化
                </div>
                <div class="item-icon" @click="goPage(1, '/smart')">
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div> -->
              <div
                class="item blue wow fadeIn"
                :style="{
                  backgroundImage: `url(${serve_area.list[1].img == undefined?'':domain + serve_area.list[1].img})`,
                }"
              >
                <div class="english-name">{{ serve_area.list[1].content }}</div>
                <div class="item-title">{{ serve_area.list[1].title }}</div>
                <div class="item-info">
                  {{ serve_area.list[1].desc }}
                </div>
                <div
                  class="item-icon"
                  @click="goPage(1, serve_area.list[1].url)"
                >
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mask-area">
          <div class="wrap">
            <div class="community">
              <!-- <div class="item county wow fadeIn">
                <div class="english-name">County medical community</div>
                <div class="item-title">县域医共体</div>
                <div class="item-info">
                  通过互联互通底层数据平台，实现”统标准、汇信息、享数据”，打造多维应用。搭建三大业务平台，分别面向管理的综合监管平台
                  (监管端)，面向医疗服务的医疗协同平台 (医生端)
                  ，以及面向群众的健康服务平台(居民端)。由以"医疗为中心”向以"健康管理与防治为中心"转变
                </div>
                <div class="item-icon" @click="goPage(1, '/chronic')">
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div> -->
              <div
                class="item county wow fadeIn"
                :style="{
                  backgroundImage: `url(${serve_area.list[2].img == undefined?'':domain + serve_area.list[2].img})`,
                }"
              >
                <div class="english-name">{{ serve_area.list[2].content }}</div>
                <div class="item-title">{{ serve_area.list[2].title }}</div>
                <div class="item-info">
                   {{ serve_area.list[2].desc }}
                </div>
                <div
                v-if="serve_area.list[2].url"
                  class="item-icon"
                  @click="goPage(1, serve_area.list[2].url)"
                >
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div>
              <!-- <div class="item chronic wow fadeIn">
                <div class="english-name">
                  Chronic disease management solutions
                </div>
                <div class="item-title">医防融合慢病管理解决方案</div>
                <div class="item-info">
                  通过互联互通底层数据平台，实现”统标准、汇信息、享数据”，打造多维应用。搭建三大业务平台，分别面向管理的综合监管平台
                  (监管端)，面向医疗服务的医疗协同平台 (医生端)
                  ，以及面向群众的健康服务平台(居民端)。由以"医疗为中心”向以"健康管理与防治为中心"转变
                </div>
                <div class="item-icon" @click="goPage(1, '/chronic')">
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div> -->
              <div
                class="item chronic wow fadeIn"
                :style="{
                  backgroundImage: `url(${serve_area.list[3].img == undefined?'':domain + serve_area.list[3].img})`,
                }"
              >
                <div class="english-name">
                  {{ serve_area.list[3].content }}
                </div>
                <div class="item-title">{{ serve_area.list[3].title }}</div>
                <div class="item-info">
                  {{ serve_area.list[3].desc }}
                </div>
                <div
                  class="item-icon"
                  @click="goPage(1, serve_area.list[3].url)"
                >
                  <img src="../assets/img/icon/icon_gd2@2x.png" alt="" />
                </div>
              </div>
              <div class="item more wow fadeIn">
                <div class="item-title">了解详情</div>
                <div class="item-info">
                  <div>获取详细内容</div>
                  <div>了解更多我们的服务</div>
                </div>
                <!-- <div class="item-icon" >
                <img src="../assets/img/icon/icon_gd4@2x.png" alt="" />
              </div> -->
              </div>
            </div>
            <div class="advantage">
              <!-- <div class="title">
                <div class="t1 wow fadeIn">我们的优势</div>
                <div class="info wow fadeIn">应用科技力量 护佑生命健康</div>
              </div> -->
              <div
                class="title"
                :style="{
                  backgroundImage: `url(${advantage_area.img == undefined?'':domain + advantage_area.img})`,
                }"
              >
                <div class="t1 wow fadeIn">{{ advantage_area.title }}</div>
                <div class="info wow fadeIn">{{ advantage_area.info }}</div>
              </div>
              <div class="advantage-list">
                <!-- <div class="advantage-item wow bounceInLeft">
                  <div class="advantage-icon">
                    <img src="../assets/img/icon/icon_cpys1@2x.png" alt="" />
                  </div>
                  <div class="advantage-title">产品优势</div>
                  <div class="advantage-content">
                    我们具备专业科研团队，根据国家相关政策，结合最新技术研发设计产品且不断更新迭代，给用户带来极致体验
                  </div>
                </div> -->
                <div class="advantage-item wow bounceInLeft">
                  <div class="advantage-icon">
                    <img :src="advantage_area.list[0].img ==undefined?'': domain + advantage_area.list[0].img" alt="" />
                  </div>
                  <div class="advantage-title">
                    {{ advantage_area.list[0].title }}
                  </div>
                  <div class="advantage-content">
                    {{ advantage_area.list[0].content }}
                  </div>
                </div>
                <!-- <div class="advantage-item wow bounceIn">
                  <div class="advantage-icon">
                    <img src="../assets/img/icon/icon_fwys1@2x.png" alt="" />
                  </div>
                  <div class="advantage-title">服务优势</div>
                  <div class="advantage-content">
                    按照国家从业要求，企业行业标准严格规范、标准化执行项目实施交付，设立24小时400人工坐席，FQA专业解答处理
                  </div>
                </div> -->
                <div class="advantage-item wow bounceIn">
                  <div class="advantage-icon">
                    <img :src="advantage_area.list[1].img == undefined?'': domain + advantage_area.list[1].img" alt="" />
                  </div>
                  <div class="advantage-title">
                    {{ advantage_area.list[1].title }}
                  </div>
                  <div class="advantage-content">
                    {{ advantage_area.list[1].content }}
                  </div>
                </div>
                <!-- <div class="advantage-item wow bounceInRight">
                  <div class="advantage-icon">
                    <img src="../assets/img/icon/icon_yyys@2x.png" alt="" />
                  </div>
                  <div class="advantage-title">运营优势</div>
                  <div class="advantage-content">
                    及时总结推广有益经验，发挥典型示范带动作用，合理引导社会预期，提高社会认知度和支持度
                  </div>
                </div> -->
                <div class="advantage-item wow bounceInRight">
                  <div class="advantage-icon">
                    <img :src="advantage_area.list[2].img==undefined ?'':domain + advantage_area.list[2].img" alt="" />
                  </div>
                  <div class="advantage-title">
                    {{ advantage_area.list[2].title }}
                  </div>
                  <div class="advantage-content">
                    {{ advantage_area.list[2].content }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-area">
        <div class="wrap">
          <!-- <div class="title">
            <div class="t1 wow fadeIn">关于我们</div>
          </div>
          <div class="about-info wow fadeIn">
            我们以强化基层医疗卫生机构服务质量及提升居民健康管理水平为目标，整合家庭医生、公卫体检、慢病预警三大智慧服务场景，融合物联网、医疗健康等领域前沿技术，基于⾃主研发的⾏业PaaS平台，为基层医疗客户提供云计算SaaS产品及服务，帮助基层提升医疗服务能⼒和数字化升级，推进分级诊疗，实现云计算新⽣态，助⼒健康中国
          </div> -->
          <div
            class="title"
            :style="{ backgroundImage: `url(${about_us.img == undefined?'':domain + about_us.img})` }"
          >
            <div class="t1 wow fadeIn">{{ about_us.title }}</div>
          </div>
          <div class="about-info wow fadeIn">
            {{ about_us.content }}
          </div>
          <div class="opt-area">
            <div class="btn more-btn" @click="goPage(4)">了解更多</div>
            <div class="btn" @click="goPage(3)">公司新闻</div>
          </div>
        </div>
        <div class="copyright-area">
          <div class="wrap">
            <div class="company-name">
              <div class="name">版权所有© 上海鸢飞信息技术有限公司</div>
              <div class="compay-slogan">
                <img src="../assets/img/slogan@2x.png" alt="" />
              </div>
            </div>
            <!-- <div class="copyright">
              Copyright© 2019 | Powered by | 版权所有© 上海鸢飞信息技术有限公司
              | 苏ICP备2021013868号 | 苏公网安备32039102000286号
            </div> -->
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import 'swiper/css/swiper.css'
import { getIdex, banner,aboutUs } from "../network/http_api";
import { BASEDOMAIN } from "../common/config";
export default {
  name: "swiper-example-vertical",
  title: "Vertical slider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      about_us1:'',
      domain: "",
      ts: false,
      bannerHeight: 0,
      isShowConnet: false,
      isShowQR: false,
      
      bannerList: [{ img: "", title: "", desc: "" }],
      swiperOption: {
        loop: true,
        speed: 1200,
        autoplay: false,
        // direction: "vertical",
        // mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      serve_area: {
        title: "我们为您提供专业的服务",
        info: "应用科技力量 护佑生命健康",
        img: "",
        list: [
          {
            content: "Family Doctor Solutions",
            desc: "充分围绕管理签、约、履、管、续各个流程进行全流程管理，致力于基层居民健康信息系统健身，实现闭环式管理，数据实时上传，有证可依，有据可查",
            id: 0,
            img: "",
            title: "家庭医生解决方案",
            url: "",
          },
          {
            content: "Smart public health solutions",
            desc: "以智能终端机为核心，通过身份证识别面部信息采集，搭载N个并列式系统及对应的数字化检测设备，一站式完成全体检流程、实现公共卫生服务过程中无纸化、信息化、智能化、规范化",
            id: 1,
            img: "",
            title: "智慧公卫解决方案",
            url: "",
          },
          {
            content: "County medical community",
            desc: "",
            id: 2,
            img: "",
            title: "县域医共体",
            url: "",
          },
          {
            content: "Chronic disease management solutions",
            desc: `通过互联互通底层数据平台，实现”统标准、汇信息、享数据”，打造多维应用。搭建三大业务平台，分别面向管理的综合监管平台
                  (监管端)，面向医疗服务的医疗协同平台 (医生端)
                  ，以及面向群众的健康服务平台(居民端)。由以"医疗为中心”向以"健康管理与防治为中心"转变`,
            id: 3,
            img: "",
            title: "医防融合慢病管理解决方案",
            url: "",
          },
        ],
      },
      advantage_area: {
        title: "我们的优势",
        info: "应用科技力量 护佑生命健康",
        img: "",
        list: [
          {
            content:
              "我们具备专业科研团队，根据国家相关政策，结合最新技术研发设计产品且不断更新迭代，给用户带来极致体验",
            desc: "",
            id: 1,
            img: "",
            title: "产品优势",
            url: "",
          },
          {
            content:
              "按照国家从业要求，企业行业标准严格规范、标准化执行项目实施交付，设立24小时400人工坐席，FQA专业解答处理",
            desc: "",
            id: 2,
            img: "",
            title: "服务优势",
            url: "",
          },
          {
            content:
              "及时总结推广有益经验，发挥典型示范带动作用，合理引导社会预期，提高社会认知度和支持度",
            desc: "",
            id: 6,
            img: "",
            title: "运营优势",
            url: "",
          },
        ],
      },
      about_us: {
        title: "关于我们",
        content:
          "我们以强化基层医疗卫生机构服务质量及提升居民健康管理水平为目标，整合家庭医生、公卫体检、慢病预警三大智慧服务场景，融合物联网、医疗健康等领域前沿技术，基于⾃主研发的⾏业PaaS平台，为基层医疗客户提供云计算SaaS产品及服务，帮助基层提升医疗服务能⼒和数字化升级，推进分级诊疗，实现云计算新⽣态，助⼒健康中国",
        img: "",
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  mounted() {
    this.domain = BASEDOMAIN;
    document.documentElement.scrollTop = 1;
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
    this.$nextTick(() => {
      this.bannerHeight = this.$refs.banner.offsetHeight;
    });
    this.getData();
    this.getBanner();
    this.getlinkData()
  },
  methods: {
     async getlinkData() {
      let res = await aboutUs();
      if (res.code == 200) {
        // let enterprise_profile = JSON.parse(res.data.enterprise_profile);
        // let development_history = JSON.parse(res.data.development_history);
        // let enterprise_honor = JSON.parse(res.data.enterprise_honor);
        // let certificate_honor = JSON.parse(res.data.certificate_honor);
        // let corporate_witness = JSON.parse(res.data.corporate_witness);
        // let partner = JSON.parse(res.data.partner);
        this.about_us1 = JSON.parse(res.data.about_us);
        //console.log('about_us',this.about_us1);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("aboutUs", res);
    },
    async getBanner() {
      let res = await banner(1);
      if (res.code == 200) {
        this.bannerList = res.data;
      } else {
        this.$message.error(res.msg);
      }

      //console.log("banner", res);
    },
    async getData() {
      let res = await getIdex();
      if (res.code == 200) {
        let serve_list = res.data[1].slice(1);
        let advantage_list = res.data[2].slice(1);
        this.serve_area = {
          title: res.data[1][0].title,
          info: res.data[1][0].content,
          img: res.data[1][0].img,
          list: serve_list,
        };
        //console.log("serve", this.serve_area);
        this.advantage_area = {
          title: res.data[2][0].title,
          info: res.data[2][0].content,
          img: res.data[2][0].img,
          list: advantage_list,
        };
        this.about_us = res.data[3][0];
        //console.log("serve_area", this.serve_area);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("res", res);
    },
   
    goPage(idx, path) {
      if (idx == 4) {
        this.$router.push("/about");
      } else if (idx == 3) {
        this.$router.push("/news");
      } else {
        this.$router.push(path);
      }
      this.$bus.$emit("headerIdx", idx);
    },
   
  },
};
</script>

<style lang="scss" scoped>
.tol {
  position: relative;
}
.contain {
  .wrap {
    width: 1200px;
    margin: 0 auto;
    // background-color: skyblue;
  }
}
.banner {
  // height: 100vh;
  // overflow: hidden;
  // background: url("../assets/img/stbg@2x.png") no-repeat;
  // background-size: cover;
  .caption {
    width: 576px;
    // height: 180px;
    font-size: 72px;
    font-weight: bold;
    color: #ffffff;
    line-height: 90px;
    // margin-top: 367px;
    margin-bottom: 60px;
  }
  .caption-info {
    font-size: 39px;
    font-weight: 400;
    color: #ffffff;
    line-height: 46px;
  }
}
.serve-area {
  color: #fff;
  background: url("../assets/img/bg1@2x.png") no-repeat fixed;
  background-size: cover;
  overflow: hidden;
  .provide {
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 755px;
      height: 258px;
      background: url("../assets/img/provide@2x.png") no-repeat center center;
      background-size: 100%;
      text-align: center;
      margin-left: 50%;
      margin-bottom: 70px;
      transform: translateX(-50%);
      .t1 {
        font-size: 42px;
        font-weight: bold;
        letter-spacing: 2px;
      }
      .info {
        font-size: 24px;
        margin-top: 10px;
      }
    }
    .plans {
      display: flex;
      .item {
        position: relative;
        width: 370px;
        padding: 24px 35px;
        padding-bottom: 0;
        background: #fff;
        overflow: hidden;
        .english-name {
          font-size: 18px;
          font-weight: 400;
          color: #c8c9cc;
          line-height: 25px;
        }
        .item-title {
          font-size: 30px;
          font-weight: 500;
          color: #1d7bff;
          line-height: 35px;
          margin-bottom: 12px;
        }
        .item-info {
          font-size: 16px;
          font-weight: 400;
          color: #202020;
          line-height: 25px;
          margin-bottom: 95px;
          overflow: hidden;
          -webkit-line-clamp: 4;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .item-icon {
          position: absolute;
          right: 35px;
          bottom: 24px;
          float: right;
          width: 56px;
          height: 56px;
          margin-top: 15px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
      .blue {
        background: #1d7bff;
        color: #fff;
        .item-title {
          color: #fff;
        }
        .item-info {
          color: #fff;
        }
      }
    }
  }
  .mask-area {
    background: rgba(0, 0, 0, 0.4);
    .community {
      display: flex;
      .item {
        height: 243px;
        width: 380px;
        padding: 24px 20px;
        background: #10245c;
        overflow: hidden;
        .english-name {
          font-size: 18px;
          font-weight: 400;
          color: #c8c9cc;
          line-height: 25px;
          margin-bottom: 12px;
        }
        .item-title {
          font-size: 30px;
          font-weight: 500;
          line-height: 35px;
        }
      }
      .county {
        position: relative;
        display: flex;
        // align-items: center;
        // justify-content: center;
        flex-direction: column;
        // text-align: center;
        width: 401px;
        .item-title {
          font-size: 30px;
          font-weight: 500;
          line-height: 35px;
          margin-bottom: 12px;
        }
        .item-info {
            font-size: 16px;
          font-weight: 400;
          line-height: 25px;
           overflow: hidden;
          -webkit-line-clamp: 4;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .item-icon {
          position: absolute;
          right: 35px;
          bottom: 24px;
          float: right;
          width: 56px;
          height: 56px;
          margin-top: 15px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
      .chronic {
        position: relative;
        width: 500px;
        padding: 24px 35px;
        color: #fff;
        background:#1d7bff url("../assets/img/image_zhgwjjfa@2x.png") no-repeat center
          center;
        background-size: 100%;
        overflow: hidden;
        .english-name {
          font-size: 18px;
          font-weight: 400;
          color: #c8c9cc;
          line-height: 25px;
        }
        .item-title {
          font-size: 30px;
          font-weight: 500;

          line-height: 35px;
          margin-bottom: 12px;
        }
        .item-info {
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;
           overflow: hidden;
          -webkit-line-clamp: 4;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .item-icon {
          position: absolute;
          right: 20px;
          bottom: 20px;
          float: right;
          width: 56px;
          height: 56px;
          margin-top: 15px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
      .more {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 150px;
        background: #fff;
        text-align: center;
        // padding: 23px 27px;
        .item-title {
          color: #000;
          margin-bottom: 6px;
        }
        .item-info {
          color: #909090;
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;
          overflow: hidden;
         
        }
        .item-icon {
          position: absolute;
          right: 20px;
          bottom: 20px;
          float: right;
          width: 56px;
          height: 56px;
          margin-top: 15px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
    }
    .advantage {
      margin-top: 78px;
      padding-bottom: 84px;

      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 755px;
        height: 258px;
        background: url("../assets/img/advantage@2x.png") no-repeat center
          center;
        background-size: 100%;
        text-align: center;
        margin-left: 50%;
        margin-bottom: 70px;
        transform: translateX(-50%);
        .t1 {
          font-size: 42px;
          font-weight: bold;
          letter-spacing: 2px;
        }
      }
    }
    .advantage-list {
      display: flex;
      justify-content: space-between;
      .advantage-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 290px;
        height: 260px;
        background: #fff;
        padding: 66px 39px;
        .advantage-icon {
          width: 82px;
          height: 82px;
          margin-bottom: 5px;
          img {
            width: 100%;
          }
        }
        .advantage-title {
          width: 112px;
          font-size: 28px;
          font-weight: 500;
          color: #1d7bff;
          margin-bottom: 30px;
        }
        .advantage-content {
          font-size: 17px;
          font-weight: 400;
          color: #202020;
          line-height: 27px;
          letter-spacing: 2px;
            overflow: hidden;
          -webkit-line-clamp: 5;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
.about-area {
  position: relative;
  overflow: hidden;
  padding-bottom: 170px;
  background: url("../assets/img/bg2@2x.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 755px;
    height: 258px;
    background: url("../assets/img/icon/Aboutus@2x.png") no-repeat center center;
    background-size: 100%;
    text-align: center;
    margin-left: 50%;
    margin-bottom: 70px;
    transform: translateX(-50%);
    .t1 {
      color: #fff;
      font-size: 42px;
      font-weight: bold;
      letter-spacing: 2px;
    }
  }
  .about-info {
    width: 900px;
    // font-size: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    margin: 23px auto 0;
  line-height: 27px;
          letter-spacing: 3px;
          overflow: hidden;
          -webkit-line-clamp: 4;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
  }
  .opt-area {
    display: flex;
    justify-content: center;
    margin-left: 50%;
    margin-top: 50px;
    transform: translateX(-50%);
    .btn {
      width: 80px;
      height: 30px;
      font-size: 20px;
      color: #ffffff;
      padding: 10px 22px;
      border: 1px solid #fff;
      margin: 0 52px;
      cursor: pointer;
    }
  }
}
.copyright-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  overflow: hidden;
  .company-name {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 27px 0 20px 0;
    .name {
    }
    .compay-slogan {
      //  height: 41px;
      width: 468px;
      margin-bottom: 11px;
      img {
        // height: 100%;
        width: 100%;
      }
    }
  }
  .copyright {
    text-align: center;
    margin-bottom: 11px;
  }
}

.swiper {
  height: 100vh;
  width: 100%;
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    // text-align: center;
    font-weight: bold;
    background: url("") no-repeat;
    background-size: cover;
  }
}
</style>